import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { PublicShell } from "./PublicQuote";
import { Star, CheckCircle2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PublicRating() {
  const { token } = useParams();
  const [o, setO] = useState(null);
  const [err, setErr] = useState("");
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [fb, setFb] = useState("");
  const [done, setDone] = useState(false);

  useEffect(() => {
    axios.get(`${API}/public/rating/${token}`).then(r => { setO(r.data); if (r.data.already_rated){ setDone(true); setRating(r.data.rating||0); } }).catch(()=>setErr("Link invalid."));
  }, [token]);

  const submit = async () => {
    if (!rating) return toast.error("Please choose a star rating");
    try {
      const { data } = await axios.post(`${API}/public/rating/${token}`, { rating, feedback: fb });
      setDone(true);
      toast.success("Thanks for the feedback!");
      if (data?.google_review_url && rating >= 4) {
        setTimeout(() => { window.location.href = data.google_review_url; }, 1500);
      }
    }
    catch(e){ toast.error(e.response?.data?.detail || "Failed"); }
  };

  if (err) return <PublicShell><p className="text-center p-8">{err}</p></PublicShell>;
  if (!o) return <PublicShell><p className="text-center p-8 text-[#757169]">Loading…</p></PublicShell>;

  return (
    <PublicShell>
      <div className="mb-6">
        <div className="label-tiny mb-1">How did we do?</div>
        <h1 className="font-display text-3xl tracking-tight">Rate your order</h1>
        <div className="text-sm text-[#757169]">Order {o.order_no} · for {o.customer_name}</div>
      </div>

      {done ? (
        <div className="card-surface p-8 text-center">
          <CheckCircle2 className="mx-auto text-[#4A7258] mb-3" size={40}/>
          <div className="font-display font-bold text-lg">Thanks!</div>
          <div className="flex justify-center mt-3 gap-1">
            {[1,2,3,4,5].map(n => <Star key={n} size={22} fill={n<=rating?"#D99036":"none"} stroke="#D99036" />)}
          </div>
          {rating >= 4
            ? <div className="text-sm text-[#757169] mt-3">Taking you to Google Reviews… <br/><span className="text-xs">If it doesn't open, <a href="https://g.page/r/Cb93uu4JM2pNEAE/review" className="underline">click here</a>.</span></div>
            : <div className="text-sm text-[#757169] mt-3">We're grateful for the feedback. Our team will use it to do better.</div>
          }
        </div>
      ) : (
        <div className="card-surface p-8">
          <div className="flex justify-center gap-2 mb-6" onMouseLeave={()=>setHover(0)}>
            {[1,2,3,4,5].map(n => (
              <button key={n}
                onMouseEnter={()=>setHover(n)}
                onClick={()=>setRating(n)}
                data-testid={`rate-${n}`}
                className="transition-transform hover:scale-110">
                <Star size={40} fill={n <= (hover||rating) ? "#D99036" : "none"} stroke="#D99036" strokeWidth={1.5} />
              </button>
            ))}
          </div>
          <div className="label-tiny mb-2">Anything to add? (optional)</div>
          <textarea rows={4} className="input-field mb-4" value={fb} onChange={e=>setFb(e.target.value)} placeholder="What was great — or where can we improve?"/>
          <div className="flex justify-end"><button className="btn-primary" onClick={submit} data-testid="rate-submit">Submit</button></div>
        </div>
      )}
    </PublicShell>
  );
}
